import LaunchDarkly from 'integrations/launchdarkly';

import './i18n';
import * as serviceWorker from './serviceWorker';

import {RouterProvider} from 'react-router-dom';

import {router} from 'router/router';

import {createRoot} from 'react-dom/client';

// window.global ||= window;

void (async () => {
  const LaunchDarklyProvider = await LaunchDarkly.Provider();

  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(
    <LaunchDarklyProvider>
      <RouterProvider router={router()} />
    </LaunchDarklyProvider>,
  );
})();

serviceWorker.unregister();
